/**
 * 点位采集实体
 * zxw
 * 创建时间：2025-05-20
 * 更新时间：2026-06-30
*/

import CNF from '../../incs/Config';
import { useEffect, useState } from 'react';
import {
    Modal,
    Input,
    message,
    DatePicker,
    Select,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, CurrentDate } from '../../incs/FunHelper';

/** 
* 日期样式
*/
import dayjs from 'dayjs';

const CURRENTDATE = CurrentDate();

const MODULENAME = '点位采集';
const { TextArea } = Input;
const { Text } = Typography;

const CollectEntity = (props) => {
    const { open, setOpen, record, refresh } = props;
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [affiliateUnit, setAffiliateUnit] = useState('');
    const [startDate, setStartDate] = useState(CurrentDate());
    const [exportTemplate, setExportTemplate] = useState(CNF.pointLocationExportTemplates[0].value);
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (open && record) {
            setNumber(record.number);
            setName(record.name);
            setAffiliateUnit(record.affiliate_unit);
            setStartDate(record.start_date);
            setExportTemplate(record.export_template);
            setDescription(record.description);
        }
    }, [open, record]);

    const cancel = () => {
        setLoading(false);
        setOpen(false);
        setName('');
        setNumber('');
        setAffiliateUnit('');
        setStartDate(CURRENTDATE);
        setExportTemplate(CNF.pointLocationExportTemplates[0].value);
        setDescription('');
    };

    const ok = () => {
        // 参数校验
        if (number === '') {
            messageApi.error(MODULENAME + '编码不能为空！', CNF.messageDuration);
            return;
        }
        if (name === '') {
            messageApi.error(MODULENAME + '名称不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'pointLocations/collects' + (record ? '/' + record.key : ''),
            headers: AddRequestHeaders(),
            type: record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                number: number,
                name: name,
                affiliate_unit: affiliateUnit,
                start_date: startDate,
                export_template: exportTemplate,
                description: description
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            if (data.status === 422) {
                messageApi.error(data.statusText, CNF.messageDuration);
            } else {
                messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            }
        }).always(function () {
            setTimeout(function () {
                setLoading(false);
            }, CNF.messageDuration * 1000);
        })
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={(record ? '修改' : '创建') + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex gap='small' vertical>
                    <Flex vertical style={{ width: '100%' }}>
                        <Text>编码<Text type='danger'>*</Text></Text>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setNumber(e.target.value)}
                            value={number}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex vertical style={{ width: '100%' }}>
                        <Text>名称<Text type='danger'>*</Text></Text>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex vertical style={{ width: '100%' }}>
                        <Text>所属单位</Text>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setAffiliateUnit(e.target.value)}
                            value={affiliateUnit}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex gap='small'>
                        <Flex vertical style={{ width: '40%' }}>
                            <Text>开始日期</Text>
                            <DatePicker
                                onChange={(_, dateString) => { setStartDate(dateString ? dateString : CURRENTDATE) }}
                                placeholder='请选择日期'
                                value={dayjs(startDate, 'YYYY-MM-DD')}
                                style={{ width: '100%' }}
                                disabled={loading}
                            />
                        </Flex>
                        <Flex vertical style={{ width: '60%' }}>
                            <Text>下载模版</Text>
                            <Select
                                value={exportTemplate}
                                style={{ width: '100%' }}
                                onChange={(value) => setExportTemplate(value)}
                                disabled={loading}
                                options={CNF.pointLocationExportTemplates.map((item, index) => ({
                                    key: index,
                                    value: item.value,
                                    label: item.key,
                                }))}
                            />
                        </Flex>
                    </Flex>
                    <Flex vertical style={{ width: '100%' }}>
                        <Text>备注</Text>
                        <TextArea
                            placeholder={'请输入'}
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Flex>
                </Flex>
            </Modal>
        </>
    );
};

export default CollectEntity